import React from 'react';
import ReactDOM from 'react-dom';
import domready from 'domready';
import Modal from './components/Modal';
import { cookieModal, existingCustomerWithOrders } from './lib/constants';
import Cookie from 'modules/cookie';

const showForUser = window.Raise.data.emailPromoModal.showForUser;

domready(() => {
  const hideModal = Cookie.isPresent([cookieModal.name]) || !showForUser;
  const $containerEl = document.getElementById('promo-modal');
  const csrf = document.querySelector('meta[name=csrf-token]').content;

  if (!hideModal && !Cookie.isPresent([existingCustomerWithOrders])) {
    const modal = <Modal csrfToken={csrf} />;
    if ($containerEl) ReactDOM.render(modal, $containerEl);
  }
});



/** WEBPACK FOOTER **
 ** ./apps/emailPromoModal/index.js
 **/